import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { BaseLink } from "shared/components/common/base-link";
import { fontRobotoCondensed, theme } from "shared/lib/styles";

import { EntityLink } from "scmp-app/components/entity-link";
import { PlusWidgetTheme } from "scmp-app/components/plus/plus-widget";
import { PlusWidgetLightThemeStyle } from "scmp-app/components/plus/plus-widget/styles";

export const LabelContainer = styled.div``;

export const HeadlineLink = styled(EntityLink)`
  &:hover {
    color: #ffffff;
    text-decoration: underline;
  }
`;

type HeadlineProps = {
  $theme?: string;
};

export const Headline = styled.div<HeadlineProps>`
  color: #ffffff;
  font-weight: 700;
  font-size: 20px;
  line-height: 130%;
  ${props =>
    props.$theme === PlusWidgetTheme.LIGHT &&
    css`
      color: #000000;
    `}
`;

export const StyledPlusArticleTypeLink = styled(BaseLink)`
  color: #8ab2ff;
  font-weight: 700;
  font-size: 12px;
  line-height: 14.06px;
  text-transform: uppercase;
  text-decoration: underline;
`;

export const TypeOrSectionLabel = styled.div`
  color: #8ab2ff;
  font-weight: 700;
  font-size: 12px;
  line-height: 14.06px;
  text-transform: uppercase;
`;

export const CoverLink = styled(EntityLink)`
  display: block;

  border-radius: 4px;

  cursor: pointer;

  overflow: hidden;

  ${theme.breakpoints.up("tablet")} {
    max-inline-size: 208px;
  }

  ${theme.breakpoints.up("desktop")} {
    max-inline-size: none;
  }

  img {
    border-radius: 4px;
  }
`;

type ContainerProps = {
  $plusWidgetTheme: PlusWidgetTheme;
};

export const Container = styled.div<ContainerProps>`
  display: flex;
  flex-direction: column;
  gap: 12px;

  font-family: ${fontRobotoCondensed};

  &:has(${CoverLink}:hover) {
    ${Headline} {
      text-decoration: underline;
    }
  }

  ${props =>
    props.$plusWidgetTheme === PlusWidgetTheme.LIGHT &&
    css`
      ${PlusWidgetLightThemeStyle.Container}
      ${HeadlineLink} {
        padding-block-end: 8px;
      }
      ${Headline} {
        ${PlusWidgetLightThemeStyle.Headline}
      }
      ${LabelContainer} {
        ${PlusWidgetLightThemeStyle.LabelContainer}
      }
      ${StyledPlusArticleTypeLink}, ${TypeOrSectionLabel} {
        ${PlusWidgetLightThemeStyle.Label}
      }
      ${StyledPlusArticleTypeLink} {
        text-decoration: none;
      }
      ${theme.breakpoints.between("tablet", "desktop")} {
        flex: 1;
        ${HeadlineLink} {
          flex: 1;
        }
        ${CoverLink} {
          max-inline-size: 100%;
        }
      }
      &:has(${CoverLink}:hover) {
        ${Headline} {
          color: #2c4692;
          text-decoration: none;
        }
      }
    `}
`;
